import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a98909c")

_pushScopeId("data-v-1a98909c")
const _hoisted_1 = { class: "ques" }
const _hoisted_2 = { class: "q-cont" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("开始编程")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("我的答案")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("此题已作答")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("请点击“开始编程”按钮填写答案")
const _hoisted_7 = {
  key: 2,
  class: "answer-area"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("dt", null, "答案：", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看代码")
const _hoisted_10 = /*#__PURE__*/_createVNode("dt", null, "得分：", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("dt", null, "解析：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.quesData.totalSort ? _ctx.quesData.totalSort + '.' : ''), 1),
      _createVNode("span", {
        innerHTML: _ctx.quesData.questionContent
      }, null, 8, ["innerHTML"]),
      _createTextVNode(_toDisplayString(_ctx.quesData.score ? '（' + _ctx.quesData.score + '分）' : ''), 1)
    ]),
    (!_ctx.showAnswer)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          class: "btn",
          onClick: _ctx.handleStartProgram
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showAnswer)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          disabled: !_ctx.quesData.status,
          type: "primary",
          class: "btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleViewCode(_ctx.quesData.lang, _ctx.quesData.studentAnswer)))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode("p", {
      class: `notice ${!_ctx.quesData.status ? 'undone' : ''}`
    }, [
      (_ctx.quesData.status)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_5
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.quesData.status)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showAnswer)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("dl", null, [
            _hoisted_8,
            _createVNode("dd", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: _ctx.quesData.rightAnswer === '',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleViewCode(_ctx.quesData.lang, _ctx.quesData.rightAnswer)))
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createVNode("dl", null, [
            _hoisted_10,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.studentScore), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_11,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.analysis ? _ctx.quesData.analysis : '略'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})